import { render, staticRenderFns } from "./InternalDossierOrderParts.vue?vue&type=template&id=204b9150&scoped=true"
import script from "./InternalDossierOrderParts.vue?vue&type=script&lang=js"
export * from "./InternalDossierOrderParts.vue?vue&type=script&lang=js"
import style0 from "./InternalDossierOrderParts.vue?vue&type=style&index=0&id=204b9150&prod&lang=css"
import style1 from "./InternalDossierOrderParts.vue?vue&type=style&index=1&id=204b9150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b9150",
  null
  
)

export default component.exports